import { differenceInCalendarDays, startOfDay } from "date-fns/esm";

import { AiChatSession } from "../types";

type AiChatHistorySection = {
  label: string;
  chats: AiChatSession[];
};

const getAiChatHistorySectionLabel = (updatedAt: Date, now: Date) => {
  const dayDifference = differenceInCalendarDays(startOfDay(now), startOfDay(updatedAt));

  if (dayDifference <= 0) {
    return "Today";
  }

  if (dayDifference === 1) {
    return "Yesterday";
  }

  return `${dayDifference} days ago`;
};

export const groupAiChatHistoryChatsByUpdatedAt = (
  chats: AiChatSession[],
  now: Date = new Date()
): AiChatHistorySection[] => {
  const sortedChats = [...chats].sort(
    (firstChat, secondChat) =>
      new Date(secondChat.updatedAt).getTime() - new Date(firstChat.updatedAt).getTime()
  );

  return sortedChats.reduce<AiChatHistorySection[]>((sections, chat) => {
    const sectionLabel = getAiChatHistorySectionLabel(new Date(chat.updatedAt), now);
    const lastSection = sections.at(-1);

    if (lastSection && lastSection.label === sectionLabel) {
      lastSection.chats.push(chat);
      return sections;
    }

    return [...sections, { label: sectionLabel, chats: [chat] }];
  }, []);
};
